import {GET_REDEMPTION_ACCOUNT_TOKEN, GET_REDEMPTION_ACCOUNT_TOKEN_RESET} from "./user";

export const GET_GIFT = 'GIFTYA/GET_GIFT';
export const GET_GIFT_RESET = 'GIFTYA/GET_GIFT_RESET';
export const GET_GIFT_FROM_HASH = 'GIFTYA/GET_GIFT_FROM_HASH';
export const GET_GIFT_FROM_HASH_RESET = 'GIFTYA/GET_GIFT_FROM_HASH_RESET';
export const POLL_E_GIFT = 'GIFTYA/POLL_E_GIFT';
export const POLL_E_GIFT_RESET = 'GIFTYA/POLL_E_GIFT_RESET';
export const GET_E_GIFT = 'GIFTYA/GET_E_GIFT';
export const GET_E_GIFT_RESET = 'GIFTYA/GET_E_GIFT_RESET';
export const CONNECT_CARD = 'GIFTYA/CONNECT_CARD';
export const CONNECT_CARD_RESET = 'GIFTYA/CONNECT_CARD_RESET';
export const DISCONNECT_CARD = 'GIFTYA/DISCONNECT_CARD';
export const DISCONNECT_CARD_RESET = 'GIFTYA/DISCONNECT_CARD_RESET';
export const DELETE_REDEMPTION_ACCOUNT = 'GIFTYA/DELETE_REDEMPTION_ACCOUNT';
export const DELETE_REDEMPTION_ACCOUNT_RESET = 'GIFTYA/DELETE_REDEMPTION_ACCOUNT_RESET';
export const GET_EXCHANGE_OPTIONS = 'GIFTYA/GET_EXCHANGE_OPTIONS';
export const GET_EXCHANGE_OPTIONS_RESET = 'GIFTYA/GET_EXCHANGE_OPTIONS_RESET';
export const CONVERT_TO_E_GIFT = 'GIFTYA/CONVERT_TO_E_GIFT';
export const CONVERT_TO_E_GIFT_RESET = 'GIFTYA/CONVERT_TO_E_GIFT_RESET';
export const UPDATE_GIFT_BALANCE = 'GIFTYA/UPDATE_GIFT_BALANCE';
export const UPDATE_GIFT_BALANCE_RESET = 'GIFTYA/UPDATE_GIFT_BALANCE_RESET';
export const CREATE_GIFT_REDEMPTION_ACCOUNT_LINK = 'GIFTYA/CREATE_GIFT_REDEMPTION_ACCOUNT_LINK';
export const CREATE_GIFT_REDEMPTION_ACCOUNT_LINK_RESET = 'GIFTYA/CREATE_GIFT_REDEMPTION_ACCOUNT_LINK_RESET';
export const REORDER_GIFT = 'GIFTYA/REORDER_GIFT';
export const REORDER_GIFT_RESET = 'GIFTYA/REORDER_GIFT_RESET';
export const GET_RECEIVED_GIFTS = 'GIFTYA/GET_RECEIVED_GIFTS';
export const GET_RECEIVED_GIFTS_RESET = 'GIFTYA/GET_RECEIVED_GIFTS_RESET';
export const GET_SENT_GIFTS = 'GIFTYA/GET_SENT_GIFTS';
export const GET_SENT_GIFTS_RESET = 'GIFTYA/GET_SENT_GIFTS_RESET';
export const GET_ORDER = 'GIFTYA/GET_ORDER';
export const GET_ORDER_RESET = 'GIFTYA/GET_ORDER_RESET';
export const CHANGE_GIFT_RECIPIENT = 'GIFTYA/CHANGE_GIFT_RECIPIENT';
export const CHANGE_GIFT_RECIPIENT_RESET = 'GIFTYA/CHANGE_GIFT_RECIPIENT_RESET';
export const CHANGE_GIFT_DATE_SEND = 'GIFTYA/CHANGE_GIFT_DATE_SEND';
export const CHANGE_GIFT_DATE_SEND_RESET = 'GIFTYA/CHANGE_GIFT_DATE_SEND_RESET';
export const SELF_GIFT_CHANGE_GIFT_RECIPIENT = 'GIFTYA/SELF_GIFT_CHANGE_GIFT_RECIPIENT';
export const SELF_GIFT_CHANGE_GIFT_RECIPIENT_RESET = 'GIFTYA/SELF_GIFT_CHANGE_GIFT_RECIPIENT_RESET';
export const EXCHANGE_GIFT_MERCHANT = 'GIFTYA/EXCHANGE_GIFT_MERCHANT';
export const EXCHANGE_GIFT_MERCHANT_RESET = 'GIFTYA/EXCHANGE_GIFT_MERCHANT_RESET';
export const EXCHANGE_GIFT_VIRTUAL_VISA = 'GIFTYA/EXCHANGE_GIFT_VIRTUAL_VISA';
export const EXCHANGE_GIFT_VIRTUAL_VISA_RESET = 'GIFTYA/EXCHANGE_GIFT_VIRTUAL_VISA_RESET';
export const EXCHANGE_GIFT_PHYSICAL_VISA = 'GIFTYA/EXCHANGE_GIFT_PHYSICAL_VISA';
export const EXCHANGE_GIFT_PHYSICAL_VISA_RESET = 'GIFTYA/EXCHANGE_GIFT_PHYSICAL_VISA_RESET';
export const SEND_THANKYA = 'GIFTYA/SEND_THANKYA';
export const SEND_THANKYA_RESET = 'GIFTYA/SEND_THANKYA_RESET';
export const REFUND_GIFT = 'GIFTYA/REFUND_GIFT';
export const REFUND_GIFT_RESET = 'GIFTYA/REFUND_GIFT_RESET';
export const GIFTYA_SELECT_SELECT_MERCHANT = 'GIFTYA/GIFTYA_SELECT_SELECT_MERCHANT';
export const GIFTYA_SELECT_SELECT_MERCHANT_RESET = 'GIFTYA/GIFTYA_SELECT_SELECT_MERCHANT_RESET';

export const giftyaSelectSelectMerchant = (payload, meta = {}, error = false) => ({
    type: GIFTYA_SELECT_SELECT_MERCHANT,
    payload,
    meta,
    error
});
export const giftyaSelectSelectMerchantReset = (payload, meta, error) => ({
    type: GIFTYA_SELECT_SELECT_MERCHANT_RESET,
    payload,
    meta,
    error
});

export const getGift = (payload, meta = {}, error = false) => ({
    type: GET_GIFT,
    payload,
    meta,
    error
});
export const getGiftReset = (payload, meta, error) => ({
    type: GET_GIFT_RESET,
    payload,
    meta,
    error
});

export const getGiftFromHash = (payload, meta = {}, error = false) => ({
    type: GET_GIFT_FROM_HASH,
    payload,
    meta,
    error
});
export const getGiftFromHashReset = (payload, meta, error) => ({
    type: GET_GIFT_FROM_HASH_RESET,
    payload,
    meta,
    error
});

export const getEGift = (payload, meta = {}, error = false) => ({
    type: GET_E_GIFT,
    payload,
    meta,
    error
});
export const getEGiftReset = (payload, meta, error) => ({
    type: GET_E_GIFT_RESET,
    payload,
    meta,
    error
});

export const pollEGift = (payload, meta = {}, error = false) => ({
    type: POLL_E_GIFT,
    payload,
    meta,
    error
});
export const pollEGiftReset = (payload, meta, error) => ({
    type: POLL_E_GIFT_RESET,
    payload,
    meta,
    error
});

export const connectCard = (payload, meta = {}, error = false) => ({
    type: CONNECT_CARD,
    payload,
    meta,
    error
});
export const connectCardReset = (payload, meta, error) => ({
    type: CONNECT_CARD_RESET,
    payload,
    meta,
    error
});

export const disconnectCard = (payload, meta = {}, error = false) => ({
    type: DISCONNECT_CARD,
    payload,
    meta,
    error
});
export const disconnectCardReset = (payload, meta, error) => ({
    type: DISCONNECT_CARD_RESET,
    payload,
    meta,
    error
});

export const deleteRedemptionAccount = (payload, meta = {}, error = false) => ({
    type: DELETE_REDEMPTION_ACCOUNT,
    payload,
    meta,
    error
});
export const deleteRedemptionAccountReset = (payload, meta, error) => ({
    type: DELETE_REDEMPTION_ACCOUNT_RESET,
    payload,
    meta,
    error
});

export const getExchangeOptions = (payload, meta = {}, error = false) => ({
    type: GET_EXCHANGE_OPTIONS,
    payload,
    meta,
    error
});
export const getExchangeOptionsReset = (payload, meta, error) => ({
    type: GET_EXCHANGE_OPTIONS_RESET,
    payload,
    meta,
    error
});

export const convertToEGift = (payload, meta = {}, error = false) => ({
    type: CONVERT_TO_E_GIFT,
    payload,
    meta,
    error
});
export const convertToEGiftReset = (payload, meta, error) => ({
    type: CONVERT_TO_E_GIFT_RESET,
    payload,
    meta,
    error
});

export const updateGiftBalance = (payload, meta = {}, error = false) => ({
    type: UPDATE_GIFT_BALANCE,
    payload,
    meta,
    error
});
export const updateGiftBalanceReset = (payload, meta, error) => ({
    type: UPDATE_GIFT_BALANCE_RESET,
    payload,
    meta,
    error
});

export const createGiftRedemptionAccountLink = (payload, meta = {}, error = false) => ({
    type: CREATE_GIFT_REDEMPTION_ACCOUNT_LINK,
    payload,
    meta,
    error
});
export const createGiftRedemptionAccountLinkReset = (payload, meta, error) => ({
    type: CREATE_GIFT_REDEMPTION_ACCOUNT_LINK_RESET,
    payload,
    meta,
    error
});

export const reorderGift = (payload, meta = {}, error = false) => ({
    type: REORDER_GIFT,
    payload,
    meta,
    error
});
export const reorderGiftReset = (payload, meta, error) => ({
    type: REORDER_GIFT_RESET,
    payload,
    meta,
    error
});

export const getReceivedGifts = (payload, meta = {}, error = false) => ({
    type: GET_RECEIVED_GIFTS,
    payload,
    meta,
    error
});
export const getReceivedGiftsReset = (payload, meta, error) => ({
    type: GET_RECEIVED_GIFTS_RESET,
    payload,
    meta,
    error
});

export const getSentGifts = (payload, meta = {}, error = false) => ({
    type: GET_SENT_GIFTS,
    payload,
    meta,
    error
});
export const getSentGiftsReset = (payload, meta, error) => ({
    type: GET_SENT_GIFTS_RESET,
    payload,
    meta,
    error
});

export const getOrder = (payload, meta = {}, error = false) => ({
    type: GET_ORDER,
    payload,
    meta,
    error
});
export const getOrderReset = (payload, meta, error) => ({
    type: GET_ORDER_RESET,
    payload,
    meta,
    error
});

export const getRedemptionAccountToken = (payload, meta = {}, error = false) => ({
    type: GET_REDEMPTION_ACCOUNT_TOKEN,
    payload,
    meta,
    error
});
export const getRedemptionAccountTokenReset = (payload, meta, error) => ({
    type: GET_REDEMPTION_ACCOUNT_TOKEN_RESET,
    payload,
    meta,
    error
});

export const changeGiftRecipient = (payload, meta = {}, error = false) => ({
    type: CHANGE_GIFT_RECIPIENT,
    payload,
    meta,
    error
});
export const changeGiftRecipientReset = (payload, meta, error) => ({
    type: CHANGE_GIFT_RECIPIENT_RESET,
    payload,
    meta,
    error
});

export const changeGiftDateSend = (payload, meta = {}, error = false) => ({
    type: CHANGE_GIFT_DATE_SEND,
    payload,
    meta,
    error
});
export const changeGiftDateSendReset = (payload, meta, error) => ({
    type: CHANGE_GIFT_DATE_SEND_RESET,
    payload,
    meta,
    error
});

export const refundGift = (payload, meta = {}, error = false) => ({
    type: REFUND_GIFT,
    payload,
    meta,
    error
});
export const refundGiftReset = (payload, meta, error) => ({
    type: REFUND_GIFT_RESET,
    payload,
    meta,
    error
});

export const selfGiftChangeGiftRecipient = (payload, meta = {}, error = false) => ({
    type: SELF_GIFT_CHANGE_GIFT_RECIPIENT,
    payload,
    meta,
    error
});
export const selfGiftChangeGiftRecipientReset = (payload, meta, error) => ({
    type: SELF_GIFT_CHANGE_GIFT_RECIPIENT_RESET,
    payload,
    meta,
    error
});

export const exchangeGiftMerchant = (payload, meta = {}, error = false) => ({
    type: EXCHANGE_GIFT_MERCHANT,
    payload,
    meta,
    error
});
export const exchangeGiftMerchantReset = (payload, meta, error) => ({
    type: EXCHANGE_GIFT_MERCHANT_RESET,
    payload,
    meta,
    error
});

export const exchangeGiftVirtualVisa = (payload, meta = {}, error = false) => ({
    type: EXCHANGE_GIFT_VIRTUAL_VISA,
    payload,
    meta,
    error
});
export const exchangeGiftVirtualVisaReset = (payload, meta, error) => ({
    type: EXCHANGE_GIFT_VIRTUAL_VISA_RESET,
    payload,
    meta,
    error
});

export const exchangeGiftPhysicalVisa = (payload, meta = {}, error = false) => ({
    type: EXCHANGE_GIFT_PHYSICAL_VISA,
    payload,
    meta,
    error
});
export const exchangeGiftPhysicalVisaReset = (payload, meta, error) => ({
    type: EXCHANGE_GIFT_PHYSICAL_VISA_RESET,
    payload,
    meta,
    error
});

export const sendThankYa = (payload, meta = {}, error = false) => ({
    type: SEND_THANKYA,
    payload,
    meta,
    error
});
export const sendThankYaReset = (payload, meta, error) => ({
    type: SEND_THANKYA_RESET,
    payload,
    meta,
    error
});

export const CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT = 'GIFTYA/CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT';
export const createPaymentMethodWithRedemptionAccount = (payload, meta = {}, error = false) => ({
    type: CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT,
    payload,
    meta,
    error
});
export const CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT_RESET = 'GIFTYA/CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT_RESET';
export const createPaymentMethodWithRedemptionAccountReset = (payload, meta, error) => ({
    type: CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT_RESET,
    payload,
    meta,
    error
});